import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { BasicRegistrationService } from 'src/app/screens/hospital-basic-registration/services/basic-registration.service';
import { LoaderService, UtilsService } from '../../services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RPPPatientMappingService } from 'src/app/screens/rpp-patient-allocate/services/rpp-patient-mapping.service';

@Component({
  selector: 'app-induction-detail-form',
  templateUrl: './induction-detail-form.component.html',
  styleUrls: ['./induction-detail-form.component.scss'],
})
export class InductionDetailFormComponent implements OnInit, OnChanges {
  @Input() patientInductionDetails: any;
  @Input() selectedPatient: any;
  @Output() onInductionDoneChange = new EventEmitter();
  inductionPersonForm: FormGroup;
  psychiatristList: SelectItem[] = [];
  psychologistList: SelectItem[] = [];
  counsellorList: SelectItem[] = [];
  marketingList: SelectItem[] = [];
  practitionerSessionData = {
    totalPsychiatristSession: 0,
    totalPsychologistSession: 0,
    totalCounsellorSession: 0,
    assignedPsychiatristSession: 0,
    assignedPsychologistSession: 0,
    assignedCounsellorSession: 0,
  };

  serviceNames = {
    feedbackArrs: [
      'Psychological Supervision',
      'Psychological Supervision Weekly',
      'Feedback Service',
      'Feedback Calls',
      // 'Family Webinars',
      'SST',
      'CRT',
      // 'Digital Monitoring through Wearables'
    ],
    pyschologistOrTherapistArrs: [
      'Psychologist Consultation',
      'Psychologist Session Basic',
      'Psychologist Session',
      'Psychologist Consultation Monthly',
      'Psychologist Consultation Twice Week',
      'Psychologist Consultation twice',
      // 'Psychodiagnosis Psychologist',
    ],
    psychiatristArr: [
      'Psychiatrist Consultation',
      'Psychiatrist Consultation Basic',
      'Psychiatrist Consultation Premium',
      'Psychiatrist Consultation Monthly',
      'Psychiatrist Session',
      // 'Psychodiagnosis Psychiatrist'
    ],
  };

  rppAssignedList: any[] = [];

  constructor(
    private basicRegService: BasicRegistrationService,
    private loaderService: LoaderService,
    private utilService: UtilsService,
    private _fb: FormBuilder,
    private rppPatientMappingService: RPPPatientMappingService
  ) {}

  ngOnInit(): void {
    this.inductionPersonFormInit();
  }

  //handle induction form init
  inductionPersonFormInit() {
    this.inductionPersonForm = this._fb.group({
      psychiatristId: ['', Validators.required],
      psychologistId: ['', Validators.required],
      counsellorId: ['', Validators.required],
      marketingId: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patientInductionDetails'].currentValue) {
      this.rppAssignedList = this.patientInductionDetails?.rppMappingData;
      this.getAllUsers();
      this.handleGetSessionsDetails();
      this.loadDraftFromLocalStorage();
      this.inductionPersonForm.valueChanges.subscribe(values => {
        this.saveDraftToLocalStorage(values);
      });
    }
  }

  //handle get all users and mapping by user's id for dropdown list
  getAllUsers() {
    this.loaderService.isLoading.next(true);
    this.basicRegService.getAllUsers().subscribe({
      next: (res: any) => {
        this.loaderService.isLoading.next(false);
        res.data.sort((a, b) => a.label.localeCompare(b.label));

        this.psychiatristList = res.data
          .filter((practitioner: any) => practitioner.role === 15)
          .map((practitioner: any) => ({
            label: practitioner.label,
            value: practitioner.value,
          }));

        this.psychologistList = res.data
          .filter((practitioner: any) => practitioner.role === 13)
          .map((practitioner: any) => ({
            label: practitioner.label,
            value: practitioner.value,
          }));

        this.counsellorList = res.data
          .filter((practitioner: any) => practitioner.role === 16)
          .map((practitioner: any) => ({
            label: practitioner.label,
            value: practitioner.value,
          }));

        this.marketingList = res.data
          .filter(
            (practitioner: any) =>
              practitioner.role === 51 || practitioner.role === 52
          )
          .map((practitioner: any) => ({
            label: practitioner.label,
            value: practitioner.value,
          }));
      },
      error: (err) => {
        this.loaderService.isLoading.next(false);
        this.utilService.showErrorToast('Error While Getting User Data.');
      },
    });
  }

  //handle checking treatment plan filled or not
  isTreatmentPlanFilled(treatmentData: any): boolean {
    const treatmentPlan =
      treatmentData?.provisionalDiagnosisData?.treatment_plan;

    return Array.isArray(treatmentPlan) && treatmentPlan?.length > 0;
  }

  //handle checking provisional diagnosis filled or not
  isProvisionalDiagnosisFilled(treatmentData: any): boolean {
    const provisionalDiagnosisData = treatmentData?.provisionalDiagnosisData;
  
    if (!provisionalDiagnosisData) {
      return false;
    }
  
    const hasBoxOrCode =
      !!provisionalDiagnosisData.did_other_box_provisional_diagnosis ||
      !!provisionalDiagnosisData.other_box_provisional_diagnosis ||
      (Array.isArray(provisionalDiagnosisData.provisionaldiagnosisandcode) &&
        provisionalDiagnosisData.provisionaldiagnosisandcode.length > 0);
  
    const hasPrimaryOrAssociated =
      !!provisionalDiagnosisData.primary_diagnosis ||
      (Array.isArray(provisionalDiagnosisData.associated_diagnosis) &&
        provisionalDiagnosisData.associated_diagnosis.length > 0);
  
    return hasBoxOrCode && hasPrimaryOrAssociated;
  }  

  //handle induction form validation and induction complete
  handleInductionFormSubmit() {
    if (this.inductionPersonForm.invalid) {
      this.utilService.showWarningToast(
        'Please select Practitioner and Marketing Person name.'
      );
      return;
    }

    const now = new Date();

    const inductionPsychiatristId = this.inductionPersonForm.value.psychiatristId;
    const inductionPsychiatristName = this.psychiatristList.filter(
      (psychiatrist) => psychiatrist.value === inductionPsychiatristId
    )[0].label;

    const inductionPsychologistId = this.inductionPersonForm.value.psychologistId;
    const inductionPsychologistName = this.psychologistList.filter(
      (psychologist) => psychologist.value === inductionPsychologistId
    )[0].label;

    const inductionCounsellorId = this.inductionPersonForm.value.counsellorId;
    const inductionCounsellorName = this.counsellorList.filter(
      (counsellor) => counsellor.value === inductionCounsellorId
    )[0].label;

    const marketingPersonId = this.inductionPersonForm.value.marketingId;
    const marketingPersonName = this.marketingList.filter(
      (marketing) => marketing.value === marketingPersonId
    )[0].label;

    const payload = {
      inductionPsychiatristId,
      inductionPsychiatristName,
      inductionPsychologistId,
      inductionPsychologistName,
      inductionCounsellorId,
      inductionCounsellorName,
      marketingPersonId,
      marketingPersonName,
      inductionStatus: 'DONE',
      inductionTime: now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }),
      inductionDate: now.toISOString().split('T')[0],
      patientName: this.selectedPatient?.patient_name,
      patientRPPId: this.selectedPatient?.patient_rpp_id,
      patientId: this.selectedPatient?.patient_id,
    };

    if (payload) {
      this.rppPatientMappingService.updateInductionDetails(payload).subscribe({
        next: (res: any) => {
          if (res) {
            this.inductionPersonForm.reset();
            this.loaderService.isLoading.next(false);
            this.onInductionDoneChange.emit(true);
            this.utilService.showSuccessToast('Induction Done Successfully.');
            const patientId = this.selectedPatient?.patient_id;
            const key = `induction_draft_${patientId}`;
            localStorage.removeItem(key);
          }
        },
        error: (err) => {
          this.loaderService.isLoading.next(false);
          this.utilService.showErrorToast(
            'Error While Saving Induction Details.'
          );
        },
      });
    }
  }

  //handle mapping totoal session counts and mapping assigned session counts 
  handleGetSessionsDetails() {
    Object.keys(this.practitionerSessionData).forEach((key) => {
      this.practitionerSessionData[key] = 0;
    });

    this.patientInductionDetails?.enrolledServices.forEach((service) => {
      const serviceName = service?.service_name;
      const freq = service?.frequency || 0;

      if (this.serviceNames.feedbackArrs.includes(serviceName)) {
        this.practitionerSessionData.totalCounsellorSession += freq;
      }

      if (this.serviceNames.pyschologistOrTherapistArrs.includes(serviceName)) {
        this.practitionerSessionData.totalPsychologistSession += freq;
      }

      if (this.serviceNames.psychiatristArr.includes(serviceName)) {
        this.practitionerSessionData.totalPsychiatristSession += freq;
      }
    });

    if (!this.patientInductionDetails?.bookedSessionOfServices) return;

    this.patientInductionDetails.bookedSessionOfServices.forEach((service) => {
      const serviceName = service?.service_name?.trim().toLowerCase();
      const roleId = service?.assigned_type;

      if (!serviceName || roleId == null) return;

      if (
        this.serviceNames.feedbackArrs.some((name) =>
          serviceName.includes(name.trim().toLowerCase())
        ) &&
        roleId === 16
      ) {
        this.practitionerSessionData.assignedCounsellorSession++;
      }

      if (
        this.serviceNames.pyschologistOrTherapistArrs.some((name) =>
          serviceName.includes(name.trim().toLowerCase())
        ) &&
        roleId === 13
      ) {
        this.practitionerSessionData.assignedPsychologistSession++;
      }

      if (
        this.serviceNames.psychiatristArr.some((name) =>
          serviceName.includes(name.trim().toLowerCase())
        ) &&
        roleId === 15
      ) {
        this.practitionerSessionData.assignedPsychiatristSession++;
      }
    });
  }

  isAssignEmoneeds(
    rppAssignedList: any[],
    practitionerTypeId: number,
    practitionerAssignIds: number[]
  ): boolean {
    if (!rppAssignedList || rppAssignedList.length === 0) {
      return false;
    }

    const filteredByType = rppAssignedList.filter(
      (practitioner: any) => practitioner?.assigned_type === practitionerTypeId
    );

    return (
      filteredByType.length > 0 &&
      filteredByType.every(
        (practitioner: any) =>
          practitionerAssignIds.includes(practitioner?.assigned_to)
      )
    );
  } 

  loadDraftFromLocalStorage() {
    const patientId = this.selectedPatient?.patient_id;
    const key = `induction_draft_${patientId}`;
    const saved = localStorage.getItem(key);

    if (saved) {
      const draft = JSON.parse(saved);

      const hasAnyValue = Object.values(draft).some(val => val !== null && val !== '');

      if (hasAnyValue) {
        this.inductionPersonForm.patchValue(draft);
      }
    }
  }


  saveDraftToLocalStorage(values: any) {
    const patientId = this.selectedPatient?.patient_id;
    const key = `induction_draft_${patientId}`;
    localStorage.setItem(key, JSON.stringify(values));
  }

  
}
